import React, { useEffect, useState } from "react"

const Scripts = () => {
    const [active, setActive] = useState(false)

    const events = [
        "keypress",
        "mousemove",
        "touchstart",
        "touchmove",
        "click",
        "scroll",
    ]

    const loadHubSpotScript = () => {
        if (
            typeof window !== "undefined" &&
            (window.location.pathname === "/contact-us/" ||
             window.location.pathname === "/digitup-present-at-seamless-middle-east-dubai-2025/"
            || window.location.pathname === "/virtual-consult/")
        ) {
            if (!document.getElementById("hs-script-loader")) {
                const script = document.createElement("script");
                script.type = "text/javascript";
                script.id = "hs-script-loader";
                script.async = true;
                script.defer = true;
                script.src = "//js.hs-scripts.com/48799727.js";
                document.head.appendChild(script);
            }
        }
    };
    


    const gtm = () => {
        const script = document.createElement("script")
        script.setAttribute("id", "gtm")
        script.async = true
        script.defer = true
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-52DB9VC');`
        if (!document.getElementById("gtm")) document.head.appendChild(script)
    }

    // const loadDigiQAnalytics = () => {
    //     if (!document.getElementById('digiq-analytics')) {
    //         const script = document.createElement('script');
    //         script.setAttribute('id', 'digiq-analytics');
    //         script.async = true;
    //         script.defer = true;
    //         script.innerHTML = `
    //           var _paq = window._paq = window._paq || [];
    //           _paq.push(['trackPageView']);
    //           _paq.push(['enableLinkTracking']);
    //           (function() {
    //               var u="//recommendation-analytics.digitup.com/";
    //               _paq.push(['setTrackerUrl', u+'js/tracker.php']);
    //               _paq.push(['setSiteId', '1']);
    //               var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    //               g.async=true; g.src=u+'js/tracker.php'; s.parentNode.insertBefore(g,s);
    //           })();
    //       `;
    //         document.head.appendChild(script);
    //     }
    // };


    const loadCookieScript = () => {
        const excludedSlug = "/digitup-present-at-seamless-middle-east-dubai-2025/";
        const isVirtualConsult = window.location.pathname.includes("virtual-consult/");
        
        if (window.location.pathname === excludedSlug || isVirtualConsult) {
            return; // Do not load the script on these specific paths
        }
    
        const script = document.createElement("script");
        script.src = "//cdn.cookie-script.com/s/459a8838a344beebc2e9e95ce06a09a4.js";
        script.defer = true;
        script.setAttribute("charset", "UTF-8");
        document.head.appendChild(script);
    };
    

    //   const addBingMetaTag = () => {
    //     if (!document.querySelector('meta[name="msvalidate.01"]')) {
    //       const meta = document.createElement("meta")
    //       meta.name = "msvalidate.01"
    //       meta.content = "03B8B0503CA9E7A254EB81131819A4F0"
    //       document.head.appendChild(meta)
    //     }
    //   }

    const loadRUMScript = () => {
        if (!document.getElementById("digitup-rum")) {
            const script = document.createElement("script")
            script.id = "digitup-rum"
            script.src = "https://rum.digitupcentral.com/rum.b4dfb85b.min.js"
            script.defer = true
            script.onload = () => {
                if (typeof rum === "function") {
                    rum("config", {
                        server: "https://rum.digitupcentral.com/collect",
                        siteId: "Digitup-New-Website",
                        brand: "Digitup",
                        market: "India",
                    })
                }
            }
            document.head.appendChild(script)
        }
    }

    const loadMetaPixel = () => {
        if (!document.getElementById("fb-pixel-script")) {
            const script = document.createElement("script")
            script.id = "fb-pixel-script"
            script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '662903259680912');
        fbq('track', 'PageView');
      `
            document.head.appendChild(script)
        }

        if (!document.getElementById("fb-pixel-noscript")) {
            const noscript = document.createElement("noscript")
            noscript.id = "fb-pixel-noscript"
            noscript.innerHTML = `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=662903259680912&ev=PageView&noscript=1" />
      `
            document.body.appendChild(noscript)
        }
    }

    const handleEvent = () => {
        setActive(true)
        // googleTag()
        // universalAnalytics()
        gtm()
        //loadDigiQAnalytics()
        loadCookieScript()
        // cookieBot()
        // zendesk()
        // zendeskFormHide()
        loadHubSpotScript()
        // addBingMetaTag()
        loadMetaPixel()
        loadRUMScript()
        events.forEach(event => window.removeEventListener(event, handleEvent))
    }

    useEffect(() => {
        events.forEach(event => window.addEventListener(event, handleEvent))
        const timeoutId = setTimeout(() => {
            if (!active) {
                handleEvent()
            }
        }, 6000) // 12 seconds

        return () => {
            clearTimeout(timeoutId)
            events.forEach(event => window.removeEventListener(event, handleEvent))
        }
    }, [])

    return <></>
}

export default Scripts
